<template>
  <span class="acoes-foto-bolao">
    <q-btn
      style="margin-right: 10px"
      flat
      dense
      icon="add_a_photo"
      class="text-blue-7"
      aria-label="Tirar foto do bolão"
      :disable="disable"
      @click="$refs.camera.click()"
    >
      <q-tooltip>Tirar foto do bolão</q-tooltip>
    </q-btn>
    <q-btn
      style="margin-right: 10px"
      flat
      dense
      icon="cloud_upload"
      class="text-blue-7"
      aria-label="Enviar foto do bolão"
      :disable="disable"
      @click="$refs.arquivo.click()"
    >
      <q-tooltip>Enviar foto do bolão</q-tooltip>
    </q-btn>
    <input
      ref="camera"
      class="hidden"
      type="file"
      accept="image/*"
      capture="environment"
      @change="receber"
    />
    <input
      ref="arquivo"
      class="hidden"
      type="file"
      accept="image/jpeg,image/png,image/webp"
      @change="receber"
    />
  </span>
</template>

<script>
export default {
  name: 'acoes-foto-bolao',
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['arquivo'],
  methods: {
    receber(event) {
      const arquivo = event.target.files && event.target.files[0];
      event.target.value = '';
      if (arquivo) this.$emit('arquivo', arquivo);
    },
  },
};
</script>
